import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_inbound_orders_summary_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { startDate: string, endDate: string }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, OwnerReference?: string, OrderLines?: { LineNumber?: number }[], Project?: { Id?: number, LookupCode?: string, Name?: string }, PreferredWarehouse?: { Name?: string }, PreferredCarrier?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number }[], Actuals?: { TotalPackagedAmount?: number, TotalGrossWeight?: number, OrderId?: number }, Expected?: { TotalPackagedAmount?: number, OrderId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.startDate)) {
      missingRequiredInParams.push('\'startDate\'');
    }
    if (isNil(inParams.endDate)) {
      missingRequiredInParams.push('\'endDate\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PurchaseOrders/datasources/ds_inbound_orders_summary_report/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { startDate: string, endDate: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, OwnerReference?: string, OrderLines?: { LineNumber?: number }[], Project?: { Id?: number, LookupCode?: string, Name?: string }, PreferredWarehouse?: { Name?: string }, PreferredCarrier?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number }[], Actuals?: { TotalPackagedAmount?: number, TotalGrossWeight?: number, OrderId?: number }, Expected?: { TotalPackagedAmount?: number, OrderId?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.startDate)) {
      missingRequiredInParams.push('\'startDate\'');
    }
    if (isNil(inParams.endDate)) {
      missingRequiredInParams.push('\'endDate\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PurchaseOrders/datasources/ds_inbound_orders_summary_report/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { startDate: string, endDate: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, OwnerReference?: string, OrderLines?: { LineNumber?: number }[], Project?: { Id?: number, LookupCode?: string, Name?: string }, PreferredWarehouse?: { Name?: string }, PreferredCarrier?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number }[], Actuals?: { TotalPackagedAmount?: number, TotalGrossWeight?: number, OrderId?: number }, Expected?: { TotalPackagedAmount?: number, OrderId?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.startDate)) {
      missingRequiredInParams.push('\'startDate\'');
    }
    if (isNil(inParams.endDate)) {
      missingRequiredInParams.push('\'endDate\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PurchaseOrders/datasources/ds_inbound_orders_summary_report/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      startDate: string, endDate: string    }) {
        if(isNil(inParams.startDate)) {
          return true; 
        }
        if(isNil(inParams.endDate)) {
          return true; 
        }
      return false;
    }
}
